import { render, staticRenderFns } from "./NewEditGestaoDeEletivosPage.vue?vue&type=template&id=674085a3"
import script from "./NewEditGestaoDeEletivosPage.vue?vue&type=script&lang=js"
export * from "./NewEditGestaoDeEletivosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports